import React, {Component} from 'react';
import PropTypes from "prop-types";
import OpenTable from "../components/Table/OpenTable";
import generalUtil from "../utils/GeneralUtil";
import Modal from "../components/ModalForm/Modal";
import TableTypes from "../enums/TableTypes";
import Operations from "../enums/Operations";
import restUtil from "../utils/RestUtil";

const propTypes = {
    axios: PropTypes.func.isRequired
};

export class OpenIncidentsPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            modalIsShown: false,
            level: "",
            systems: [],
            emailGroups: [],
            dataCenters: [],
            data: []
        };
        this.handleEmailGroupChange = this.handleEmailGroupChange.bind(this)
        this.handleLevelChange = this.handleLevelChange.bind(this);
        this.handleSystemChange = this.handleSystemChange.bind(this);
        this.handleDataCenterChange = this.handleDataCenterChange.bind(this);
    }

    showModal = () => {
        this.setState({modalIsShown: true});
        generalUtil.toggleScrollLock();
    };

    closeModal = () => {
        this.setState({
            modalIsShown: false,
            level: "",
            emailGroups: [],
            systems: [],
            dataCenters: []
        });
        generalUtil.toggleScrollLock();
    };

    handleLevelChange(level) {
        this.setState({
            level: level.toLowerCase()
        })
    }

    // Handles change of user input in the emailGroups field when creating a new email group
    handleEmailGroupChange(emailGroups) {
        this.setState({
            emailGroups: emailGroups
        });
    }

    // Handles change of user input in the systems field when creating a new sev
    handleSystemChange(systems) {
        this.setState({
            systems: systems
        });
    }

    // Handles change of user input in the data center field when creating a new sev
    handleDataCenterChange(dataCenters) {

        this.setState({
            dataCenters: dataCenters
        });
    }

    // Handles submission of incident creation form
    incidentCreateOnSubmit = (event) => {
        event.preventDefault(event);

        let emailGroups = [];
        let systems = [];
        let dataCenters = [];

        (this.state.emailGroups).forEach((emailGroup) => {
            emailGroups.push(emailGroup.value);
        });

        (this.state.systems).forEach((system) => {
            systems.push(system.value);
        });

        (this.state.dataCenters).forEach((dataCenter) => {
            dataCenters.push(dataCenter.value);
        });

        const requestData = {
            title: event.target.title.value,
            level: this.state.level,
            start_time: event.target.start_time.value.toString(),
            slack_channel_ids: event.target.slack_channel_ids.value,
            creator: event.target.creator.value,
            owner: event.target.owner.value,
            emailGroups: emailGroups.toString(),
            systems: systems.toString(),
            data_centers: dataCenters.toString(),
            technical_update: event.target.technical_impact.value,
            customer_update: event.target.customer_impact.value,
            status_update: event.target.status_update.value,
            adhoc_emails: event.target.communication_emails.value,
            creator_jira_username: event.target.creator_jira_username.value,
            owner_jira_username: event.target.owner_jira_username.value,
            atf_sev: false
        };

        this.setState({ data: requestData });

        return restUtil.postRequest(this.props.axios, '/sevbot/incidents/create', requestData);
    }

    render() {
        return (
            <React.Fragment>
                {this.state.modalIsShown ? (<Modal
                    onSubmit={this.incidentCreateOnSubmit}
                    closeModal={this.closeModal}
                    onKeyDown={generalUtil.onKeyDown}
                    tableType={TableTypes.Open}
                    operation={Operations.Create}
                    axios={this.props.axios}
                    onLevelChange={this.handleLevelChange}
                    onEmailGroupChange={this.handleEmailGroupChange}
                    onSystemChange={this.handleSystemChange}
                    onDataCenterChange={this.handleDataCenterChange}
                    selectedLevel={this.state.level}
                    selectedEmailGroups={this.state.emailGroups}
                    selectedSystems={this.state.systems}
                    selectedDataCenters={this.state.dataCenters}
                />) : null}
                <div className='tableContainer'>
                    <OpenTable axios={this.props.axios}/>
                </div>
            </React.Fragment>
        );
    }
}

OpenIncidentsPage.propTypes = propTypes;
